export class ExampleMaster {
  id?: string;
  uuid?: string;
  input?: string;
  calendar?: string;
  dropdown?: string;
  autoCompleteCode?: string;
  autoCompleteName?: string;
  autoCompleteNameTw?: string;
  autoCompleteNameCn?: string;
  autoCompleteNameUs?: string;
  inputNumber?: number;
  calendarRange?: string[];
  custValidation?: string;
  dynamicDropdown?: string;
  autoCompleteDropdownCode?: string;
  autoCompleteDropdownName?: string;
  autoCompleteDropdownNameTw?: string;
  autoCompleteDropdownNameCn?: string;
  autoCompleteDropdownNameUs?: string;

  autoCompleteFilter?: string;
  setAutoCompleteFilter(): void {
    this.autoCompleteFilter = (this.autoCompleteCode ? this.autoCompleteCode + ' ' : '')
      + (this.autoCompleteNameTw ? this.autoCompleteNameTw + ' ' : '')
      + (this.autoCompleteNameCn ? this.autoCompleteNameCn + ' ' : '')
      + (this.autoCompleteNameUs ? this.autoCompleteNameUs : '')
  }

  autoCompleteDropdownFilter?: string;
  setAutoCompleteDropdownFilter(): void {
    this.autoCompleteDropdownFilter = (this.autoCompleteDropdownCode ? this.autoCompleteDropdownCode + ' ' : '')
      + (this.autoCompleteDropdownNameTw ? this.autoCompleteDropdownNameTw + ' ' : '')
      + (this.autoCompleteDropdownNameCn ? this.autoCompleteDropdownNameCn + ' ' : '')
      + (this.autoCompleteDropdownNameUs ? this.autoCompleteDropdownNameUs : '')
  }
}
